export default __webpack_public_path__ + "static/media/Group 8.90019b89.png";